import { DateTime } from 'aos-helpers/src/helpers/Time'
import { TFunction } from 'i18next'

import { InspectionGroup, translateInspectionGroup } from './InspectionGroup'

export interface InspectionType {
    id: number
    name: string
    inspectionGroup: InspectionGroup
    period?: number
    taskEndTime?: DateTime
}

export const translateInspectionType = (t: TFunction) => (v: InspectionType) =>
    `${translateInspectionGroup(t)(v.inspectionGroup)} / ${v.name}`
